import { getParticipantName } from "./matchDisplayUtils";

// The winner's type is the side's participant type: a team match has a team winner.
const sideWinner = (match, index) => ({
  id: match?.[`participant${index}Id`] ?? match?.[`participant_${index}_id`],
  type: match?.[`participant${index}Type`] || match?.[`participant_${index}_type`] || "user",
});

export const resolveMatchCompletion = ({ match, currentScore, confirmFn = window.confirm }) => {
  const participant1Score = currentScore?.participant1 || 0;
  const participant2Score = currentScore?.participant2 || 0;

  let winner;
  let winnerName;

  if (participant1Score > participant2Score) {
    winner = sideWinner(match, 1);
    winnerName = getParticipantName(match, "participant1");
  } else if (participant2Score > participant1Score) {
    winner = sideWinner(match, 2);
    winnerName = getParticipantName(match, "participant2");
  } else {
    const participant1Name = getParticipantName(match, "participant1");
    const participant2Name = getParticipantName(match, "participant2");

    const tieWinnerChoice = confirmFn(
      `Match is tied ${participant1Score}-${participant2Score}. Who should be declared the winner?\n\n` +
        `Click OK for ${participant1Name}\n` +
        `Click Cancel for ${participant2Name}`
    );

    if (tieWinnerChoice) {
      winner = sideWinner(match, 1);
      winnerName = participant1Name;
    } else {
      winner = sideWinner(match, 2);
      winnerName = participant2Name;
    }
  }

  const finalConfirm = confirmFn(
    `Complete this match?\n\n` +
      `Final Score: ${participant1Score} - ${participant2Score}\n` +
      `Winner: ${winnerName}`
  );

  if (!finalConfirm) {
    return { cancelled: true };
  }

  return {
    cancelled: false,
    winner,
    winnerName,
    participant1Score,
    participant2Score,
  };
};
